import { list } from '../../../../../../common/classes/request-builder';

export class SubcontratosListsDefinition {
    public fincas = list();
}
